var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ma-9"},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.feedbacks},scopedSlots:_vm._u([{key:"item.title_lesson",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.title_lesson ? item.title_lesson : 'freetalk')+" ")]}},{key:"item.name_teacher",fn:function(ref){
var item = ref.item;
return [_c('a',{attrs:{"href":("/#/user/student/" + (item.teacher_id) + "/info")}},[_vm._v(_vm._s(item.name_teacher ? item.name_teacher : ''))])]}},{key:"item.name_student",fn:function(ref){
var item = ref.item;
return [_c('a',{attrs:{"href":("/#/user/student/" + (item.student_id) + "/info")}},[_vm._v(_vm._s(item.name_student ? item.name_student : ''))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }